import { clsx } from 'clsx';

import { PropsWithChildren } from 'react';

import { SbRichTextProps } from '../types';

type RichTextOverlayProps = PropsWithChildren<
  Pick<SbRichTextProps, 'className' | 'itemProp' | 'theme'> & {
    isLight?: boolean;
    id?: string;
    dataTestId?: string;
  }
>;

export const RichTextOverlay = ({
  children,
  className,
  itemProp,
  id,
  dataTestId,
}: RichTextOverlayProps) => {
  return (
    <div
      id={id}
      itemProp={itemProp}
      data-testid={dataTestId}
      className={clsx(className, 'box-border sb-rich-text', {})}
    >
      {children}
    </div>
  );
};
